import React from 'react';
import { shopProducts } from '../data/shopData';
import { FaWhatsapp } from 'react-icons/fa';
import SocialShare from '../common/SocialShare';

const Shop = ({ lang }) => {
  // Mini Logo Component for Products (Replaces Images)
  const ProductLogo = () => (
    <div className="w-full h-full bg-black flex flex-col items-center justify-center p-4 relative overflow-hidden group-hover:bg-zinc-900 transition-colors">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-20"></div>
      <div className="text-center relative z-10 transform group-hover:scale-105 transition-transform duration-500">
        <h3 className="text-xl font-serif font-black text-white leading-none mb-1">
          EYELASHES<span className="text-mx-green">MEXICO</span>
        </h3>
        <p className="text-[8px] text-mx-gold tracking-[0.3em] uppercase">Made in Mexico</p>
      </div>
      {/* Decorative Flag Line */}
      <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-mx-green via-white to-mx-red"></div>
    </div>
  );

  return (
    <section id="shop" className="py-20 px-4 bg-zinc-950 text-white relative">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-6xl font-serif font-black mb-4 text-white">
            PRO SHOP & STANHOME
          </h2>
          <p className="text-mx-gold text-xl italic mb-8">Tienda Profesional y Colección Stanhome</p>
        </div>

        <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-6">
          {shopProducts.map((product) => (
            <div key={product.id} className="bg-white/5 border border-white/10 rounded-2xl p-4 hover:border-mx-gold transition-colors group flex flex-col h-full">
              {/* Image Area Replaced with Brand Logo */}
              <div className="aspect-square bg-black rounded-xl mb-4 overflow-hidden relative border border-white/5 shadow-inner">
                <ProductLogo />
                <div className="absolute top-2 right-2 bg-mx-red text-white text-[10px] font-bold px-2 py-1 rounded shadow-lg uppercase z-20">
                  {product.category === 'stanhome' ? 'Stanhome' : 'Sale'}
                </div>
              </div>
              
              <h3 className="font-bold text-lg mb-1 leading-tight min-h-[50px]">
                {lang === 'es' ? product.titleEs : product.titleEn}
              </h3>
              <p className="text-gray-400 text-xs italic mb-4 min-h-[40px]">
                {lang === 'es' ? product.descEs : product.descEn}
              </p>
              
              <div className="mt-auto">
                {/* Price removed as requested previously */}
                
                <a 
                  href={`https://wa.me/529841771113?text=I want to buy / Quiero comprar: ${lang === 'es' ? product.titleEs : product.titleEn}`}
                  target="_blank"
                  rel="noreferrer"
                  className="w-full bg-white text-black py-3 rounded-lg font-bold text-xs uppercase flex items-center justify-center gap-2 hover:bg-mx-gold hover:text-white transition-colors shadow-lg mb-4"
                >
                  <FaWhatsapp className="text-lg" /> Buy / Comprar
                </a>

                {/* Social Share Component Added */}
                <SocialShare 
                  title={lang === 'es' ? product.titleEs : product.titleEn}
                  text={lang === 'es' ? product.descEs : product.descEn}
                  url="https://eyelashesmexico.com"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Shop;